<template>
  <div class="animated fadeIn">
    <b-row>
        <b-col lg="12">
          <b-card>
            <b-form @submit.prevent="submit">
              <b-form-group
                label="CSV File input"
                label-for="fileInput"
                :label-cols="3">
                  <b-form-file id="fileInput" ref="file-input" class="mb-2" accept=".csv" v-model="file" :state="Boolean(file)" placeholder="Choose a csv file..." drop-placeholder="Drop file here..."  @change="loadCsvFromFile"></b-form-file>
              </b-form-group>
              <div slot="footer">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
                <b-button type="reset" size="sm" variant="danger" @click="reset"><i class="fa fa-ban"></i> Reset</b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
    </b-row>
  </div>
</template>

<script>
import csvjson from 'csvjson'
import VueNotifications from 'vue-notifications'

export default {
  name: 'GroupFromCsv',
  data () {
    return {
      file: null
    }
  },
  created() {
    this.$store.state.importResult = []
  },
  methods: {
    loadCsvFromFile(ev) {
      const file = ev.target.files[0]
      console.debug('loadCsvFromFile :', file)
    },
    reset() {
      this.file = null      
    },
    async getJson() {
      const readFile = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsText(file)
      })

      const csv = await readFile(this.file)
      const json = csvjson.toObject(csv, {
        delimiter: ',',
        quote : '"'
      })
      return json
    },
    async addUsers(users) {
      this.$store.state.importResult = []

      if (!users) {
        console.error('users is null')
        this.$options.notifications.showErrorMsg.message = 'No Users to add'
        this.showErrorMsg()
        return
      }

      users.forEach(user => {
        this.$http.post('/api/signUp', user)
        .then(response => {
          console.debug('signUp: ', response.data)
          this.$store.state.importResult.push({email: user.email, result: true, message: JSON.stringify(response.data)})
        })
        .catch(error => {
          console.error(error)
          this.$store.state.importResult.push({email: user.email, result: false, message: error.response.data.msg})
        })
      });
    },
    async submit () {
      if (!this.file) return
      console.debug('submit :', this.file)
      if (this.file.size > 10*1024) {
        this.$options.notifications.showErrorMsg.message = 'Too big.  should less then 10kBytes'
        this.showErrorMsg()
        return
      }
      
      const json = await this.getJson()
      console.debug(json)

      this.addUsers(json)
    }
  },
  notifications: {
    showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'Error',
        message: ''
    },
    showInfoMsg: {
        type: VueNotifications.types.info,
        title: 'Information',
        message: ''
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
